import { Box, Grid } from "@mui/material";

import TradeChartView from "./TradeChartView";
import TradeForm from "./TradeForm";
import TradePrices from "./TradePrices";
import TradeWalletAction from "./TradeWalletAction";

function MobileTradeWrapper({
  tradeInitial,
  tradeAmountMax,
  coinMarketDetails,
  showTradingView,
  handleShowOrHideTradingView,
  setShowMarketDrawer,
}) {
  return (
    <Box sx={{ pt: 2 }}>
      {showTradingView ? (
        <TradeChartView
          tradeInitial={tradeInitial}
          coinMarketDetails={coinMarketDetails}
          handleShowOrHideTradingView={handleShowOrHideTradingView}
        />
      ) : (
        <Grid container spacing={1}>
          <Grid item lg={8} xs={8}>
            <TradeForm
              setShowMarketDrawer={setShowMarketDrawer}
              coinMarketDetails={coinMarketDetails}
              tradeInitial={tradeInitial}
              tradeAmountMax={tradeAmountMax}
            />
          </Grid>

          <Grid item lg={4} xs={4}>
            <TradePrices coinMarketDetails={coinMarketDetails} />

            <TradeWalletAction />
          </Grid>
        </Grid>
      )}
    </Box>
  );
}

export default MobileTradeWrapper;
